import React from "react";
import "./intro.css";
import profilePic from "../../assets/image.jpg"; // Add your profile image

const Intro = () => {
  return (
    <section id="intro">
      <div className="introContent">
        <span className="hello">Hey!!</span>
        <div className="introTextWrapper">
          <div className="introTextLeft">

            <span className="introText"> I'm <span className="introName">Pragathi S Rao</span> <br />
            </span>
            <p className="introPara">
              I design and develop scalable, user-friendly web applications. 
              <br />
              Passionate about fullstack development and continuously improving my technical expertise.
            </p>
          </div>
          <div className="introProfile">
            <img src={profilePic} alt="Profile" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
